import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "key-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
        React.createElement("path", { d: "M6.5 3a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7ZM6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" }),
        React.createElement("path", { d: "m9.5 7.5 4.354 4.354a.5.5 0 0 1 .146.353V13a1 1 0 0 1-1 1h-.5a.5.5 0 0 1-.5-.5V13a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-.793a.5.5 0 0 0-.146-.353L9.5 10.5 9 10 8 9V8l1.5-.5Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
